import { Container, Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  ButtonGroupTop,
  CustomTable,
  ModalError,
  ModalSuccess,
  Page,
  PreviewImage,
  PrimaryButton,
  SearchTextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";

function Society() {
  const classes = globalStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    per_page: 10,
    search: "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/admin/society/`, {
        headers,
        params: queryParams,
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.per_page);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  const handleDelete = async id => {
    try {
      await axios.delete(`${hardBaseUrl}/admin/society/${id}`, {
        headers,
      });
      ModalSuccess("Succesfully delete society").then(() => getDataTable());
    } catch (error) {
      ModalError(error?.response ? getErrors(error?.response) : error);
    }
  };

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Page className={classes.root} title="Society">
      <Container maxWidth={false}>
        <HeaderTitle title="Parameter" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes?.flatDivider} />
        <Grid container justifyContent="space-between" my="16px">
          <Grid item>
            <SearchTextInput
              placeholder="Search"
              value={queryParams?.search}
              onChange={e =>
                handleChangeQueryParams(e?.target?.value, "search")
              }
              disabled={loadingPage}
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              label="Add Society"
              onClick={() => history.push("/admin/parameter/society/add")}
              startIcon={<Add />}
              size="large"
              disabled={loadingPage}
            />
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.per_page}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "per_page")
          }
          isHaveAction
          tooltipEdit="Update Society"
          handleEdit={item =>
            history.push(`/admin/parameter/society/edit/${item?.id}`)
          }
          deleteConfirmation
          tooltipDelete="Delete Society"
          deleteConfirmationKey="society_name"
          handleDelete={item => handleDelete(item?.id)}
        />
      </Container>
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Parameter",
    link: "/admin/parameter/society",
  },
  {
    label: "Society",
    active: true,
  },
];
const columnTable = [
  {
    name: "profile_image_url",
    title: "Logo",
    renderText: item => <PreviewImage imageUrl={item} />,
  },
  {
    name: "society_name",
    title: "Society",
  },
  {
    name: "id",
    title: "ID Society",
  },
  {
    name: "email",
    title: "Email",
  },
  {
    name: "phone_number",
    title: "Phone",
  },
];

export default Society;
